import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import axios from "axios";
import { extendMoment } from "moment-range";
import { vars } from "../../config/theme";
import LoadingModal from "./help/LoadingModal";

import {
    Box,
    LinearProgress,
    Tab,
    Tabs,
    Typography,
    Paper,
    Tooltip,
    InputLabel,
    MenuItem,
    FormControl,
    Dialog,
    DialogTitle,
    Select,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

import RoomRateGrid from "../Grid/RoomRateGrid.jsx";
import MonthPicker from "../MonthPicker/MonthPicker.jsx";
import "../../../../sass/room_rates_grid.module.scss";
import modalOpenStyle from "./modalOpenStyle.module.css";
import {
    monthNames,
    rateChangeOperations,
    editRateByRuleFormType,
    STATE_DATE_FORMAT,
    MATERIAL_UI_PROPS,
    MAX_DATA_AMNT_GAP,
    VALUE_TYPES,
} from "../../lib/data";
import config from "../../config/api";
import { useRate } from "../../hooks/use-rate";
import { useRoomRateParams } from "../../hooks/use-roomrateparams";
import { getBars } from "./help/GetBars";
import rateStyle from "./RoomRates.module.css";

const monthChangerStyles = {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    position: "sticky",
    left: "60vw",
};

const DEFAULT_ACCOMOD_BASE = {
    adults: "1",
    children: "0",
    babies: "0",
    extra_bed: "0",
    craddle: "0",
};
const DEFAULT_DATA_VALS = {
    operation: rateChangeOperations.add.value,
    value_type: VALUE_TYPES.digit.value,
    value: "0",
};
const MAX_GRID_ROWS = 1000;
const GRID_ROWS_STEP = 300;

const RoomRates = (props) => {
    const outerRoomTypes = [...props.auxData.room_types];
    const outerRates = [...props.auxData.rates];
    const { bars, childBarsIds, baseBarIds } = getBars(outerRates);

    const path = window.location.pathname;
    const formulasPath = path.replace("/manager", config.baseUrl) + "/formulas";
    const closeSale = 2;
    const activeRates = outerRates.filter((rate) => rate.active);

    //из хранилища берем выбранные тарифы, для выбора верного тарифа
    const storedStartRates = JSON.parse(
        localStorage.getItem(`selectedRates${props.hotelId}`),
    );

    const [pickedRate, setPickedRate] = useState(
        storedStartRates?.length > 0
            ? activeRates.filter((rate) =>
                  storedStartRates.includes(rate.id),
              )[0]
            : activeRates[0],
    );
    const activeRoomTypes = outerRoomTypes.filter(
        (roomType) => roomType.active,
    );

    if (activeRates.length <= 0)
        return <Typography>Нет активных тарифов</Typography>;

    const [month, setMonth] = useState(moment());

    const [monthFormVisible, setMonthFormVisible] = useState(false);
    const [editFormType, setEditFormType] = useState(
        editRateByRuleFormType.calculate,
    );
    const [maxGridRows, setMaxGridRows] = useState(MAX_GRID_ROWS);
    const [isOpenRulesModule, setIsOpenRulesModule] = useState(false);
    const [isOpenMassClossing, setIsOpenMassClossing] = useState(false);
    const [roomType, setRoomType] = useState(activeRoomTypes[0]);
    const [bases, setBases] = useState([]);

    const [daysInMonth, setDaysInMonth] = useState(month.daysInMonth());
    const [prospectMonth, setProspectMonth] = useState(month.clone());
    const [stopMonth, setStopMonth] = useState(false);
    const [openModalRates, setOpenModalRates] = useState(false);
    const [selectedRates, setSelectedRates] = useState([]);
    const [initialSelectedRatesSet, setInitialSelectedRatesSet] =
        useState(false);
    const setPickedRateHandler = (rateNew) => {
        setMaxGridRows(MAX_GRID_ROWS);
        setPickedRate(rateNew);
    };

    const date_start = month.format("YYYY-MM-01"); //first day of current month YYYY-mm-dd
    const date_end = prospectMonth.format(
        `YYYY-MM-${prospectMonth.daysInMonth()}`,
    ); //last day of current month YYYY-mm-dd

    const [vectorStops, setVectorStops] = useState([]);
    const [vectorStart, setVectorStart] = useState(false);

    const [statusActualRatesFilter, setStatusActualRatesFilter] = useState(0);

    useEffect(() => {
        const checkStatusLocalStorage = localStorage.getItem(
            "localStorageStatusFilter",
        );
        if (checkStatusLocalStorage && checkStatusLocalStorage !== null) {
            setStatusActualRatesFilter(() => Number(checkStatusLocalStorage));
        }
    }, []);

    const rate = pickedRate.id;
    const room_type = roomType.id;
    const rateRequestParams = { date_start, date_end, rate, room_type };

    useEffect(() => {
        axios
            .get(
                `/manager/data/hotels/${props.hotelId}/get_vector_stops?date_start=${date_start}&date_end=${date_end}`,
            )
            .then((res) => {
                setVectorStops(res.data);
                props.initAction(rateRequestParams);
            });
    }, [date_start, date_end, vectorStart]);

    const currentMonthNum = month.format("M");
    const currentYear = month.format("YYYY");
    const currentMonth = monthNames[currentMonthNum - 1];
    const currentProspectMonth = monthNames[prospectMonth.format("M") - 1];
    const actualRates = returnActualRatesArr(activeRates, month);

    const roomTypesArray = [];
    actualRates.forEach((rate) => {
        roomTypesArray[rate.id] = rate.room_types.filter(
            (roomType) => roomType.active,
        );
    });

    useEffect(() => {
        const storedSelectedRates = localStorage.getItem(
            `selectedRates${props.hotelId}`,
        );

        if (!storedSelectedRates) {
            const allIds = actualRates.map((rate) => rate.id);
            localStorage.setItem(
                `selectedRates${props.hotelId}`,
                JSON.stringify(allIds),
            );
            setSelectedRates(allIds);
        } else {
            setSelectedRates(JSON.parse(storedSelectedRates));
        }
    }, [openModalRates]);

    useEffect(() => {
        if (!initialSelectedRatesSet && selectedRates.length > 0) {
            setPickedRate(
                activeRates.filter((rate) =>
                    selectedRates.includes(rate.id),
                )[0],
            );
            setInitialSelectedRatesSet(true);
        }
    }, [selectedRates, initialSelectedRatesSet]);

    useEffect(() => {
        if (baseBarIds.includes(pickedRate.id)) {
            setBases(bars[pickedRate.id]);
        } else if (!childBarsIds.includes(pickedRate.id)) {
            setBases([]);
        }
    }, [pickedRate]);

    const accomTypesArr = roomType.accommodation_types
        ? parseAccomodTypes(roomType.accommodation_types)
        : createAccomodTypes(roomType.capacity, roomType.data.babies_capacity);

    const defRulesDateStart = moment().add(1, "d");
    const defRulesDateEnd = moment(date_end, STATE_DATE_FORMAT);
    let firstAccomodBase = { ...DEFAULT_ACCOMOD_BASE };

    const defaultRules = {
        rate_id: pickedRate.id,
        room_type_id: roomType.id,
        base: firstAccomodBase,
        data: [
            {
                target: firstAccomodBase,
                ...DEFAULT_DATA_VALS,
            },
        ],
        date_array: [
            {
                date_start: defRulesDateStart.format(STATE_DATE_FORMAT),
                date_end:
                    defRulesDateStart.isAfter(defRulesDateEnd) ||
                    defRulesDateStart.isSame(defRulesDateEnd)
                        ? defRulesDateStart
                              .add(1, "d")
                              .format(STATE_DATE_FORMAT)
                        : defRulesDateEnd.format(STATE_DATE_FORMAT),
            },
        ],
        additional_room_types: [
            {
                room_type_id: activeRoomTypes[0]?.id,
                ...DEFAULT_DATA_VALS,
                accommodation_types: [{ ...firstAccomodBase }],
            },
        ],
    };

    defaultRules.selectedAccTypes = getAllUniqueAccTypesFormRules(
        defaultRules.data,
    );

    defaultRules.selectedRoomTypesIds = defaultRules.additional_room_types.map(
        (roomType) => roomType.room_type_id,
    );

    if (accomTypesArr && accomTypesArr.length > 0) {
        const [adults, children, babies, extra_bed, craddle] =
            accomTypesArr[0].split(".");
        firstAccomodBase = { adults, children, babies, extra_bed, craddle };
    }

    const [rulesForChange, setRulesForChange] = useState(defaultRules);
    const [asignRules, setAsignRules] = useState({ ...defaultRules });

    // Custom hooks
    useRate({
        actualRates,
        activeRates,
        pickedRate,
        roomType,
        month,
        rateRequestParams,
        date_start,
        date_end,
        initAction: props.initAction,
        setPickedRate,
        setRulesForChange,
        defaultRules,
        formulasPath,
        setAsignRules,
        startLoading: props.startLoading,
    });

    useRoomRateParams(
        rulesForChange,
        activeRoomTypes,
        getAllUniqueAccTypesFormRules,
        createAccomodTypes,
        setRulesForChange,
    );

    const createMultpleRequests = (path, rules, dates) => {
        const extendedMoment = extendMoment(moment);
        const requstsArr = new Array();
        const rulesArr = new Array();
        const dateStartsAndEndArr = new Array();

        const datesRange = extendedMoment.range(
            dates.date_start,
            dates.date_end,
        );

        const arrOfdates = Array.from(
            datesRange.by("days", { step: MAX_DATA_AMNT_GAP }),
        );
        const filteredArrOfdates = arrOfdates.filter((momentDate) =>
            momentDate.isBetween(
                dates.date_start,
                dates.date_end,
                undefined,
                "[]",
            ),
        );

        //Для выбора день в день закомментирую, может пригодиться
        // if (
        //     !filteredArrOfdates[filteredArrOfdates.length - 1].isSame(
        //         dates.date_end
        //     )
        // )

        filteredArrOfdates.push(extendedMoment(dates.date_end));

        const oneDayPeriod = filteredArrOfdates.length === 1 ? 0 : 1;

        for (let i = 0; i < filteredArrOfdates.length; i++) {
            if (i === filteredArrOfdates.length - 1) break;

            const objOfStartAndEnd = {
                date_end:
                    filteredArrOfdates[i + oneDayPeriod].format(
                        STATE_DATE_FORMAT,
                    ),
            };

            if (i === 0) {
                objOfStartAndEnd.date_start =
                    filteredArrOfdates[i].format(STATE_DATE_FORMAT);
            } else if (i !== filteredArrOfdates.length - 1) {
                objOfStartAndEnd.date_start = filteredArrOfdates[i]
                    .add(1, "d")
                    .format(STATE_DATE_FORMAT);
            }
            dateStartsAndEndArr.push(objOfStartAndEnd);
        }

        for (const dateObj of dateStartsAndEndArr) {
            const updatedRules = { ...rules };
            updatedRules.date_start = dateObj.date_start;
            updatedRules.date_end = dateObj.date_end;

            rulesArr.push(updatedRules);
        }

        for (const rulesObj of rulesArr) {
            requstsArr.push(axios.post(path, rulesObj));
        }

        return requstsArr;
    };

    const rulesHandler = async (
        rules,
        operType,
        roomTypeVariant,
        placeTypePrice,
    ) => {
        try {
            rules.roomTypeVariant = roomTypeVariant;
            rules.placeTypePrice = placeTypePrice;
            await calculateRateWithRules(rules, operType);
            if (operType === editRateByRuleFormType.assign) return;
            const rulesFormatedToSave = formatRulesForSave(rules);
            await saveRulesOnServer(rulesFormatedToSave);
        } catch (err) {
            alert(err);
        }
    };

    const saveRulesOnServer = (rules) => axios.post(formulasPath, rules);

    const calculateRateWithRules = async (rules, operType) => {
        const failedRequests = { messages: new Set(), numOfFailedRequests: 0 };
        const path = props.pathToEditByParams + operType;
        // copy state Object to work with state
        const rulesJson = JSON.stringify(rules);
        const rulesToSend = JSON.parse(rulesJson);

        Reflect.deleteProperty(rulesToSend, "selectedAccTypes");
        Reflect.deleteProperty(rulesToSend, "selectedRoomTypesIds");
        props.switchloadAfterChangeByRule();

        if (operType === editRateByRuleFormType.assign) {
            Reflect.deleteProperty(rulesToSend, "base");
            Reflect.deleteProperty(rulesToSend, "additional_room_types");
            const changedData = [...rulesToSend.data].map((line) => {
                const updatedLine = { ...line };
                Reflect.deleteProperty(updatedLine, "operation");
                return updatedLine;
            });

            rulesToSend.data = changedData;
        } else if (operType === editRateByRuleFormType.calculate) {
            Reflect.deleteProperty(rulesToSend, "additional_room_types");
        }

        if (rulesToSend.data?.length > 0) {
            formatRulesForRequest(rulesToSend.data);
        }
        if (rulesToSend.additional_room_types?.length > 0) {
            formatRulesForRequest(rulesToSend.additional_room_types);
        }
        const preRequests = [];
        rulesToSend.date_array.forEach((dates) =>
            preRequests.push(createMultpleRequests(path, rulesToSend, dates)),
        );

        const requests = [];
        preRequests.forEach((p) => p.forEach((req) => requests.push(req)));

        const responses = await Promise.allSettled(requests);

        responses.forEach((response) => {
            if (response.status === "rejected") {
                ++failedRequests.numOfFailedRequests;
                failedRequests.messages.add(
                    response.reason.response.data?.message,
                );
            }
        });

        if (failedRequests.numOfFailedRequests > 0) {
            const errArr = Array.from(failedRequests.messages);
            alert("Возникли следующие ошибки: " + errArr);
        }
        props.switchloadAfterChangeByRule();
        props.initAction(rateRequestParams);
    };

    let pickedRateIdx = actualRates
        .filter((rate) => selectedRates.includes(rate.id))
        .indexOf(pickedRate);

    let pickedRateBar = childBarsIds?.indexOf(pickedRate.id) || 0;

    const selectRoomType = (e) => {
        setMaxGridRows(MAX_GRID_ROWS);
        setRoomType(e.target.value);
    };

    const handleMonthForm = (monthYearStr) => {
        if (!monthYearStr) return setMonthFormVisible(false);
        setMaxGridRows(MAX_GRID_ROWS);
        const [monthStr, yearStr] = monthYearStr.split(" ");
        const pickedMonthIndex = monthNames.indexOf(monthStr) + 1;

        const selMonthFirstDate = month.clone().startOf("month");
        const curMonthFirstDate = moment().startOf("month");

        setMonthFormVisible(false);
        const pickedMonth = moment(
            `${yearStr}-${pickedMonthIndex}-01`,
            STATE_DATE_FORMAT,
        );
        if (curMonthFirstDate.isAfter(pickedMonth)) {
            pickedMonth.add(1, "year");
            setMonth(pickedMonth);
            setProspectMonth(pickedMonth.clone());
            setDaysInMonth(pickedMonth.daysInMonth());
        } else if (!selMonthFirstDate.isSame(pickedMonth)) {
            setMonth(pickedMonth);
            setProspectMonth(pickedMonth.clone());
            setDaysInMonth(pickedMonth.daysInMonth());
        }
    };

    const monthExtension = (i) => {
        if (i == "add") {
            setStopMonth(true);
            setProspectMonth(prospectMonth.add(1, "month"));
            // setDaysLastMonth(prospectMonth.daysInMonth())
            setDaysInMonth(daysInMonth + prospectMonth.daysInMonth());
        }

        // if (i == 'sub') {
        //     setDaysInMonth(daysLastMonth - prospectMonth.daysInMonth())
        //     setProspectMonth(prospectMonth.subtract(1, "month"))
        //     // setDaysLastMonth(prospectMonth.daysInMonth())
        // }
    };

    const [arrowBackIcon, arrowForwardIcon] = createMonthChangerIcons(
        month,
        monthExtension,
    );

    const monthSelector = monthFormVisible && (
        <MonthPicker onClose={handleMonthForm} open={monthFormVisible} />
    );

    const monthName = (
        <Typography
            style={{ width: stopMonth && "17rem" }}
            variant="h6"
            onClick={() => !stopMonth && setMonthFormVisible(true)}
        >
            {currentMonth}{" "}
            {stopMonth && (
                <React.Fragment> - {currentProspectMonth}</React.Fragment>
            )}{" "}
            {currentYear}
        </Typography>
    );

    if (actualRates.length === 0) {
        return (
            <Box p={3}>
                <div style={monthChangerStyles}>
                    {monthSelector}
                    {arrowBackIcon}
                    {monthName}
                    {arrowForwardIcon}
                </div>
                <Typography>Нет актуальных тарифов</Typography>
            </Box>
        );
    }

    const datesInMonth = createDatesArr(month, daysInMonth);
    const activeRoomTypesEls = createActiveRoomTypesEls(activeRoomTypes);

    const cellsByRoomType = createBooleanMatrix(
        accomTypesArr.length + 1,
        daysInMonth + 1,
    );

    const changeGridRowHandler = () =>
        setMaxGridRows((prevRowNum) => (prevRowNum += GRID_ROWS_STEP));

    const openByRulesModuleHandler = (moduleIsOpen) =>
        setIsOpenRulesModule(moduleIsOpen);

    const openMassClossingHandler = (moduleIsOpen) =>
        setIsOpenMassClossing(moduleIsOpen);

    let rules = rulesForChange;
    let setRules = setRulesForChange;

    const reload = () => {
        props.initAction(rateRequestParams);
    };

    if (editFormType === editRateByRuleFormType.assign) {
        rules = asignRules;
        setRules = setAsignRules;
    }
    const grid = renderRoomRateGrid(
        setStatusActualRatesFilter,
        statusActualRatesFilter,
        props.items,
        props.objectTemplate,
        month,
        pickedRate,
        props.submitAction,
        setMonthFormVisible,
        props.errorFields,
        datesInMonth,
        roomType,
        accomTypesArr,
        rules,
        setRules,
        rulesHandler,
        editFormType,
        setEditFormType,
        activeRoomTypes,
        maxGridRows,
        cellsByRoomType,
        isOpenRulesModule,
        isOpenMassClossing,
        openByRulesModuleHandler,
        openMassClossingHandler,
        closeSale,
        setPickedRateHandler,
        daysInMonth,
        activeRates,
        reload,
        props.switchloadAfterChangeByRule,
        vectorStops,
        setVectorStart,
    );

    const filterActualRates = (arrayRates, paramsRate) => {
        return arrayRates.sort(function (a, b) {
            if (a[`${paramsRate}`] > b[`${paramsRate}`]) {
                return 1;
            }
            if (a[`${paramsRate}`] < b[`${paramsRate}`]) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });
    };

    const switcherFilterActualRates = () => {
        if (statusActualRatesFilter === 0) {
            return actualRates;
        }
        if (statusActualRatesFilter === 1) {
            return filterActualRates(actualRates, "id");
        }
        if (statusActualRatesFilter === 2) {
            return filterActualRates(actualRates, "code");
        }
        return actualRates;
    };

    const ratesNames =
        actualRates.length > 0 &&
        switcherFilterActualRates()
            .filter((rate) => selectedRates.includes(rate.id))
            .map((rate) => {
                return (
                    <Tab
                        title={rate.code !== rate.name ? rate.name : ""}
                        label={rate.code || rate.name}
                        key={`${rate.id}/${rate.code}`}
                        onClick={() => {
                            setMaxGridRows(MAX_GRID_ROWS);
                            setPickedRate(rate);
                        }}
                        onDoubleClick={() => {
                            setOpenModalRates(true);
                        }}
                    />
                );
            });

    const rates = !ratesNames ? (
        <Box p={2}>
            <Typography>Нет доступных тарифов</Typography>
        </Box>
    ) : statusActualRatesFilter !== 3 ? (
        <Tabs
            className={rateStyle.block_rates}
            value={pickedRateIdx === -1 ? 0 : pickedRateIdx}
            indicatorColor={MATERIAL_UI_PROPS.colors.primary}
            textColor={MATERIAL_UI_PROPS.colors.primary}
            variant="scrollable"
            scrollButtons="true"
        >
            {ratesNames}
        </Tabs>
    ) : (
        <></>
    );

    const basesTabs = (
        <>
            <h3 style={{ margin: "5px 15px 0" }}>Периоды цен</h3>
            <Tabs
                value={false}
                textColor={MATERIAL_UI_PROPS.colors.primary}
                variant="scrollable"
                scrollButtons="true"
            >
                {bases?.map((bar) => {
                    return (
                        <Tab
                            title={bar.code !== bar.name ? bar.name : ""}
                            label={bar.code || bar.name}
                            style={{
                                backgroundColor: bar?.color_bar,
                                color: "white",
                                borderRadius: "8px",
                                margin: "5px",
                                borderBottom:
                                    bar?.code === pickedRate?.code
                                        ? "4px solid #26ade4"
                                        : "none",
                            }}
                            key={`${bar.id}/${bar.code}-bars`}
                            onClick={() => {
                                setMaxGridRows(MAX_GRID_ROWS);
                                setPickedRate(bar);
                            }}
                        />
                    );
                })}
            </Tabs>
        </>
    );

    const roomSelector = (
        <select
            value={roomType}
            onChange={selectRoomType}
            style={{ fontWeight: 500 }}
        >
            {activeRoomTypesEls}
        </select>
    );

    const handleRateSelection = (rateId) => {
        const isRateSelected = selectedRates.includes(rateId);
        let updatedSelectedRates;
        if (isRateSelected) {
            updatedSelectedRates = selectedRates.filter((id) => id !== rateId);
        } else {
            updatedSelectedRates = [...selectedRates, rateId];
        }
        setSelectedRates(updatedSelectedRates);
        localStorage.setItem(
            `selectedRates${props.hotelId}`,
            JSON.stringify(updatedSelectedRates),
        );
    };

    return (
        <>
            <LoadingModal loading={props.loadingCustom} />
            {monthSelector}
            <Paper elevation={3}>{rates}</Paper>
            {bases?.length > 0 && (
                <div
                    style={{
                        border: "1px solid #655e5e",
                        color: "rgb(75 187 233)",
                        borderRadius: "12px",
                        padding: "20px",
                        margin: "10px",
                        display: "inline-block",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.6)",
                    }}
                >
                    {basesTabs}
                </div>
            )}
            <Box p={3}>
                <Box style={monthChangerStyles}>
                    {arrowBackIcon}
                    {monthName}
                    {arrowForwardIcon}
                </Box>
                <FormControl
                    style={{
                        marginBottom: "3rem",
                        minWidth: "11rem",
                        position: "sticky",
                        left: "16rem",
                    }}
                >
                    <InputLabel
                        style={{
                            fontWeight: "bold",
                            minWidth: "250px",
                        }}
                    >
                        Выбрать категорию номера
                    </InputLabel>
                    <Select
                        value={roomType}
                        onChange={selectRoomType}
                        style={{ fontWeight: 500 }}
                    >
                        {activeRoomTypesEls}
                    </Select>
                </FormControl>
                {grid}
            </Box>
            {cellsByRoomType.length > maxGridRows && (
                <Box pb={"1.8rem"} pl={"1.5rem"}>
                    <Typography
                        style={{
                            fontSize: "0.8rem",
                            position: "sticky",
                            left: "16rem",
                            cursor: "pointer",
                            display: "inline",
                            color: vars.brandBlue,
                            borderBottom: "2px solid #26ade4",
                        }}
                        onClick={() => changeGridRowHandler(cellsByRoomType)}
                    >
                        Показать больше типов размещения...
                    </Typography>
                </Box>
            )}
            <Dialog
                open={openModalRates}
                onClose={() => setOpenModalRates(false)}
                maxWidth="xl"
            >
                <DialogTitle>Тарифы для отображения</DialogTitle>
                {openModalRates && (
                    <div style={{ padding: "10px" }}>
                        {actualRates.map((rate) => (
                            <div key={rate.id}>
                                <input
                                    className={modalOpenStyle.inputModalRates}
                                    type="checkbox"
                                    checked={selectedRates.includes(rate.id)}
                                    onChange={() =>
                                        handleRateSelection(rate.id)
                                    }
                                    id={rate.name}
                                />
                                <label
                                    style={{ marginLeft: "5px" }}
                                    htmlFor={rate.name}
                                >
                                    {rate.name}
                                </label>
                            </div>
                        ))}
                    </div>
                )}
            </Dialog>
        </>
    );
};

// Helper functions

/**
 * Creates roomTypes elements to pick
 *
 * @param {Array} activeRoomTypes
 */

const createActiveRoomTypesEls = (roomTypes) =>
    roomTypes.map((room, idx) => (
        <MenuItem key={idx} value={room}>
            {room.name}
        </MenuItem>
    ));

/**
 * Creates array of dates according picked month
 *
 * @param {moment} month
 *
 * @returns {Array}
 */
const createDatesArr = (month, daysInMonth) => {
    const arrDates = [];
    var cloneMonth = month.clone();
    var oldDaysInMonth = 0;
    for (let i = 1; i <= daysInMonth; i++) {
        const year = cloneMonth.format("YYYY");
        const monthStr = cloneMonth.format("MM");
        const date = moment(
            `${year}-${monthStr}-${i - oldDaysInMonth}`,
            STATE_DATE_FORMAT,
        );
        arrDates.push(date);
        if (i - oldDaysInMonth === cloneMonth.daysInMonth()) {
            oldDaysInMonth += cloneMonth.daysInMonth();
            cloneMonth.add(1, "month");
        }
    }
    arrDates.unshift("placeholder");
    return arrDates;
};

/**
 * Creates boolean matrix for TableDragSelect
 *
 * @param {Number} rows
 * @param {Number} cols
 */
const createBooleanMatrix = (rows, cols) => {
    const matrix = [];
    for (let i = 0; i < rows; i++) {
        let row = [];
        for (let j = 0; j < cols; j++) {
            row.push(false);
        }
        matrix.push(row);
    }
    return matrix;
};

//
/**
 * Filter items by room type
 *
 * @param {Array} outerItems
 * @param {Object} auxRoomData
 */
const filterItems = (outerItems, auxRoomData) => {
    const items = [...outerItems];
    const roomTypeId = auxRoomData.id;

    const filteredItems = items.filter(
        (item) => +item.room_type_id === +roomTypeId,
    );

    const accomTypesObj = new Object();

    filteredItems.forEach((price) => {
        const acomTypeKey = `${price.adults}.${price.children}.${price.babies}.${price.extra_bed}.${price.craddle}`;
        if (Reflect.has(accomTypesObj, acomTypeKey)) {
            accomTypesObj[acomTypeKey].push(price);
        } else {
            accomTypesObj[acomTypeKey] = [];
            accomTypesObj[acomTypeKey].push(price);
        }
    });
    return accomTypesObj;
};

/**
 * Creates all accomodation types data
 *
 * @param {Number} capacity
 */

const createAccomodTypes = (capacity, babiesCapacity) => {
    const accTypes = [];

    for (let i = 1; i <= capacity; i++) {
        for (let j = 0; j < capacity; j++) {
            for (let k = 0; k <= parseInt(babiesCapacity); k++) {
                if (i + j > capacity) {
                    continue;
                }
                const accomodType = `${i}.${j}.${k}`;

                accTypes.push(accomodType);
            }
        }
    }

    return createSortedAccTypes(accTypes);
};

/**
 * Sort roomtypes for main accomodation types to be on top
 * @param {string[]} accTypes
 * @returns properly sorted room types
 */

const createSortedAccTypes = (accTypes) => {
    if (!accTypes || accTypes.length <= 0) return;
    const mainAccomTypesArr = [];
    const secAccomTypesArr = [];

    for (let i = 0; i < accTypes.length; i++) {
        const accType = accTypes[i].split(".");
        const children = accType[1];
        const babies = accType[2];

        if (children === "0" && babies === "0") {
            mainAccomTypesArr.push(accTypes[i]);
            continue;
        }
        secAccomTypesArr.push(accTypes[i]);
    }
    const acc = mainAccomTypesArr.concat(secAccomTypesArr);
    const renderAcc = [];

    acc.forEach((a) => {
        for (let e = 0; e < 2; e++) {
            for (let c = 0; c < 2; c++) {
                const type = `${a}.${e}.${c}`;
                renderAcc.push(type);
            }
        }
    });

    return renderAcc;
};

/**
 * Parses accomodation data from backend
 * @param {string} jsonData
 * @returns {string[]} accomodation data
 */

const parseAccomodTypes = (serverAccomodTypes) => {
    const parsed = Array.isArray(serverAccomodTypes)
        ? serverAccomodTypes
        : JSON.parse(serverAccomodTypes);

    const accTypes = parsed.map(
        (accType) => `${accType.adults}.${accType.children}.${accType.babies}`,
    );

    return createSortedAccTypes(accTypes);
};

/**
 * Creates back and forward arrow icons for table
 *
 * @param {moment} month
 * @param {Function} onMonthChange
 */

const createMonthChangerIcons = (month, monthExtension) => {
    const selectedMontFirstDate = month.format("YYYY-MM-01");
    const selectedDateToCompare = moment(
        selectedMontFirstDate,
        STATE_DATE_FORMAT,
    );

    const currentMonth = moment();
    const yearAhead = moment().add(1, "year");
    const cloneMonth = month.clone();
    const backIcon = null;

    const forwardIcon = month.isBefore(yearAhead) && (
        <Tooltip title="Добавить следующий месяц">
            <ArrowForwardIcon
                fontSize={MATERIAL_UI_PROPS.sizes.small}
                className="arrow-month-icon-room-rate"
                onClick={() => {
                    monthExtension("add");
                }}
            />
        </Tooltip>
    );

    return [backIcon, forwardIcon];
};

/**
 * Creates all grids
 *
 * @param {Array} items
 * @param {Object} objectTemplate
 * @param {moment} pickedMonth
 * @param {Object} rate
 * @param {Function} submitAction
 * @param {Function} setMonthFormVisible
 *
 *
 * @returns {Object}
 */

const renderRoomRateGrid = (
    setStatusActualRatesFilter,
    statusActualRatesFilter,
    items,
    objectTemplate,
    pickedMonth,
    rate,
    submitAction,
    setMonthFormVisible,
    errorFields,
    monthDates,
    roomType,
    accomTypesArr,
    rulesForChange,
    setRulesForChange,
    startCalculationWithRules,
    editFormType,
    setEditFormType,
    roomTypes,
    maxGridRows,
    cellsByRoomType,
    isOpenRulesModule,
    isOpenMassClossing,
    openByRulesModuleHandler,
    openMassClossingHandler,
    closeSale,
    setPickedRateHandler,
    daysInMonth,
    activeRates,
    reload,
    switchloadAfterChangeByRule,
    vectorStops,
    setVectorStart,
) => {
    const filteredItems = filterItems(items, roomType);

    return (
        <RoomRateGrid
            setStatusActualRatesFilter={setStatusActualRatesFilter}
            statusActualRatesFilter={statusActualRatesFilter}
            accomodTypes={accomTypesArr}
            roomType={roomType}
            filteredItems={filteredItems}
            objectTemplate={objectTemplate}
            rate={rate}
            onMonthSelect={() => setMonthFormVisible(true)}
            updateData={submitAction}
            errorFields={errorFields}
            month={pickedMonth}
            monthDates={monthDates}
            cells={cellsByRoomType}
            rulesForChange={rulesForChange}
            setRulesForChange={setRulesForChange}
            startCalculationWithRules={startCalculationWithRules}
            editFormType={editFormType}
            setEditFormType={setEditFormType}
            roomTypes={roomTypes}
            maxGridRows={maxGridRows}
            isOpenRulesModule={isOpenRulesModule}
            isOpenMassClossing={isOpenMassClossing}
            openByRulesModuleHandler={openByRulesModuleHandler}
            openMassClossingHandler={openMassClossingHandler}
            closeSale={closeSale}
            setPickedRate={setPickedRateHandler}
            daysInMonth={daysInMonth}
            activeRates={activeRates}
            reload={reload}
            switchloadAfterChangeByRule={switchloadAfterChangeByRule}
            vectorStops={vectorStops}
            setVectorStart={setVectorStart}
        />
    );
};

/**
 * Return array of rates that are active in given dates
 *
 * @param {Array} rates
 * @param {moment} curMonth
 */

const returnActualRatesArr = (rates, curMonth) => {
    const curDate = moment().format(STATE_DATE_FORMAT);
    const filteredRates = rates.filter((rate) => {
        const rateMomentEndDate = moment(rate.date_end, STATE_DATE_FORMAT);
        if (
            rateMomentEndDate >= curMonth ||
            rateMomentEndDate.isBetween(
                curMonth.startOf("month").format(STATE_DATE_FORMAT),
                curMonth.endOf("month").format(STATE_DATE_FORMAT),
                undefined,
                "[]",
            )
        )
            return true;
    });
    return filteredRates;
};

const getAllUniqueAccTypesFormRules = (dataLines) => {
    const accTypesSet = new Set();
    const accTypesArr = new Array();

    dataLines.forEach((line) => {
        const copyLine = JSON.stringify(line.target);
        accTypesSet.add(copyLine);
    });

    accTypesSet.forEach((accType) => accTypesArr.push(JSON.parse(accType)));

    return accTypesArr;
};

const formatRulesForRequest = (rules) => {
    for (let rule of rules) {
        if (rule.value_type === VALUE_TYPES.percent.value) {
            switch (rule.operation) {
                case rateChangeOperations.add.value:
                    rule.value = (+rule.value / 100 + 1).toFixed(2).toString();
                    break;
                case rateChangeOperations.subtract.value:
                    rule.value = (1 - +rule.value / 100).toFixed(2).toString();
            }

            rule.operation = rateChangeOperations.multiply.value;
        }
        Reflect.deleteProperty(rule, "value_type");
    }
};

const formatRulesForSave = (rules) => {
    const formattedRules = { data: [] };
    const baseRoom = {
        rate_id: rules.rate_id,
        room_type_id: rules.room_type_id,
        formulas: rules.data.map((rule) => rule),
    };
    formattedRules.data.push(baseRoom);

    for (let i = 0; i < rules.additional_room_types.length; i++) {
        if (rules.additional_room_types[i].value === "0") continue;
        const additionalRoom = {
            rate_id: rules.rate_id,
            room_type_id: rules.additional_room_types[i].room_type_id,
            formulas: rules.additional_room_types[i].accommodation_types.map(
                (accType) => {
                    return {
                        operation: rules.additional_room_types[i].operation,
                        value: rules.additional_room_types[i].value,
                        value_type: rules.additional_room_types[i].value_type,
                        target: accType,
                    };
                },
            ),
        };
        formattedRules.data.push(additionalRoom);
    }

    return formattedRules;
};

RoomRates.propTypes = {
    auxData: PropTypes.object.isRequired,
    initAction: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    objectTemplate: PropTypes.object.isRequired,
    submitAction: PropTypes.func.isRequired,
    errorFields: PropTypes.object,
    updateAction: PropTypes.func.isRequired,
    pathToEditByParams: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    switchloadAfterChangeByRule: PropTypes.func.isRequired,
    hotelId: PropTypes.object,
};

export default RoomRates;
